import { render, staticRenderFns } from "./RegistrationIframe.vue?vue&type=template&id=bfd6b1ce&"
import script from "./RegistrationIframe.vue?vue&type=script&lang=ts&"
export * from "./RegistrationIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports